import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import { AppInitialProps } from '../../@types'
import { RuntimeConfigs, StaticConfigs } from '../../config'

export const initSentry = (authToken: AppInitialProps['authToken']) => {
  const { network, networkPublicInfo, member } = authToken || {}
  let allowUrls
  try {
    allowUrls = [networkPublicInfo?.domain, ...network.aliases].map(
      // eslint-disable-next-line prefer-template, prettier/prettier, no-useless-escape
    str => new RegExp('https?:\/\/((cdn|www)\.)?' + str))
    // eslint-disable-next-line no-empty
  } catch (e) {}

  Sentry.init({
    dsn: RuntimeConfigs.SENTRY_DSN,
    environment: RuntimeConfigs.RELEASE_CHANNEL,
    integrations: [new BrowserTracing()],
    allowUrls,
    tracesSampler: samplingContext => {
      if (samplingContext.transactionContext.name === 'ChunkLoadError') {
        return 0
      }
      return 0.3
    },
    release: `web-app@${StaticConfigs.APP_VERSION}`,
    enabled: StaticConfigs.IS_PROD,
    ignoreErrors: [
      `ChunkLoadError`,
      `FirebaseError`,
      `Failed to register a ServiceWorker`,
    ],
  })

  if (networkPublicInfo) {
    Sentry.setTag('user.networkId', networkPublicInfo.id || '')
    Sentry.setTag('user.networkName', networkPublicInfo.name || '')
    Sentry.setTag('user.networkDomain', networkPublicInfo.domain || '')
  }
  if (member) {
    Sentry.setTag('user.roleType', member.role?.type || '')
    Sentry.setTag('user.status', member.status || '')
    Sentry.setUser({
      email: member.email,
      id: member.id,
      username: member.username,
      plan: network?.subscriptionPlan?.name,
    })
  }
}
